import React from 'react';
import { Link } from "react-router-dom";
import Logo from "../../elements/logo/Logo";
import { FiX } from "react-icons/fi";
import { useTranslation } from "react-i18next";

const MobileMenu = ({show, onClose}) => {
    const { i18n } = useTranslation();

    const handleToggleLang = (e) => {
        e.preventDefault();
        const cur = (i18n && i18n.language) ? i18n.language : 'en';
        const next = String(cur).toLowerCase().startsWith('en') ? 'zh' : 'en';
        i18n.changeLanguage(next);
    };

    const isEnUI = String((i18n && i18n.language) ? i18n.language : 'en').toLowerCase().startsWith('en');

    const handleLinkClick = () => {
        onClose();
    };

    return (
        <div className={`popup-mobile-menu ${show ? "active": ""}`}>
            <div className="inner">
                <div className="header-top">
                    <Logo 
                        image={`${process.env.PUBLIC_URL}/images/logo/logo-cyberate.png`}
                        image2={`${process.env.PUBLIC_URL}/images/logo/logo-cyberate.png`}
                    />
                    <div className="close-menu">
                        <span className="close-button" onClick={onClose}><FiX /></span>
                    </div>
                </div>
                <nav className="mobile-nav">
                    <ul className="mobile-menu-list">
                        <li><Link to="/" onClick={handleLinkClick}>Home</Link></li>
                        <li><Link to="/Service" onClick={handleLinkClick}>Our Services</Link></li>
                        <li><Link to="/CaseStudy" onClick={handleLinkClick}>Case Study</Link></li>
                        <li><Link to="/AboutUs" onClick={handleLinkClick}>About Us</Link></li>
                        <li><Link to="/Contact" onClick={handleLinkClick}>Contact Us</Link></li>
                        <li><Link to="/FreeConsult" onClick={handleLinkClick} className="mobile-free-consult">Free Consult</Link></li>
                        <li><a href="#lang" onClick={handleToggleLang}>{isEnUI ? 'EN/中文' : '中文/EN'}</a></li>
                    </ul>
                </nav>
            </div>
        </div>
    )
}
export default MobileMenu;